<template lang="pug">
  .container-payment-mobile
    //- c-header
      template(slot="left")
        //- h3 收款账户详情
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/paymentList") 收款账户管理
          el-breadcrumb-item 收款账户详情
    cBox
      .account-title
        .display-block {{ accountDetail.desc }}
        .small.grey {{ accountDetail.account_id }}
      el-button(type="primary", @click="showEditAccount").display-block 修改账户名称
    cBox.account-list-title
      c-header-small
        template(slot="left") 绑定结算帐号
        el-button(type="primary", @click="showEditBinding", slot="right", v-if="settle_type === 1") 更改
    cBox(v-for="l in accountList.list", :key="l.id").account-item
      .account-item-content
        .display-block 开户姓名或公司名称
        .grey {{ l.deposit_name }}
      .account-item-content
        .display-block 开户银行
        .grey {{ l.deposit_bank }}
      .account-item-content
        .display-block 银行卡号
        .grey {{ l.bank_account }}
      .account-item-content
        .display-block 添加时间
        .grey {{ l.create_time }}
      .account-item-content
        .display-block 状态
        .grey {{ l.status | acccountStatus }}
    .container-pagination
      el-pagination(layout="prev, pager, next, total",
        :current-page="accountList.page", :total="accountList.total", :page-size="accountList.size",
        @size-change="changeListSize", @current-change="getAccountList")

    hr(v-if="settle_type === 2")
    cBox(v-if="settle_type === 2")
      c-header-small
        template(slot="left") 富力钱包
        template(slot="right") 
          el-button(type="primary", @click="showCreateWallet", v-if="!walletConfig.status") 添加钱包
          el-button(type="primary", @click="toWalletVerify(account_id)", v-else-if="walletConfig.status === 1") 验证
          el-button(type="primary", @click="toWalletDetail(account_id)", v-else) 详情
          el-button(@click="getWalletConfig") 刷新
      el-form(:model="accountDetail",label-position="right",label-width="150px")
        el-form-item(label="钱包状态", v-if="!walletConfig.status") 未绑定
        el-form-item(label="钱包状态", v-else-if="walletConfig.status === 1") 待验证
        el-row(:gutter="10", v-else)
          el-col(:span="12")
            el-form-item(label="钱包状态") 已验证
          el-col(:span="12")
            el-form-item(label="账户余额") {{ walletConfig.balance }}

    el-dialog(title="修改账户名称", :visible.sync="editAccount.show", width="100%")
      .data-block
        data-row(label="收款账户名称", required)
          el-input(v-model="editAccount.desc")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveEditAccount()") 保存
        el-button(@click="hideEditAccount()") 取消

    el-dialog(title="绑定结算账户", :visible.sync="editBinding.show", top="0" width="100%", v-loading="editBinding.loading")
      cBox(v-for="l in editBinding.accountList", :key="l.id").account-item
        .account-item-content
          .display-block 开户姓名或公司名称
          .grey {{ l.deposit_name }}
        .account-item-content
          .display-block 开户银行
          .grey {{ l.deposit_bank }}
        .account-item-content
          .display-block 银行卡号
          .grey {{ l.bank_account }}
        .account-item-content
          .display-block 添加时间
          .grey {{ l.create_time }}
        .account-item-content
          .display-block 状态
          .grey {{ l.status | acccountStatus }}
        .account-item-content
          .display-block 状态
          .grey {{ l.bind_status | acccountBindStatus }}
        .account-item-content
          el-button(size="small", type="primary", @click="toEditBinding(l.id)", v-if="l.bind_status === 1 && iface.toBind").display-block 绑定
          el-button(size="small", @click="toEditUnbinding(l.id)", v-if="l.bind_status === 2 && iface.toUnbind").display-block 解绑
      .dialog-footer(slot="footer")
        //- el-button(@click="toSettleList()") 结算账户管理
        el-button(@click="hideEditBinding()") 关闭

    el-dialog(title="开通微众钱包", :visible.sync="createWallet.show", width="100%", top="10%")
      .data-block
        data-row(label="收款账户名称") {{ createWallet.source.desc }}
        data-row(label="收款账户 ID") {{ createWallet.source.account_id }}
      .data-block
        data-row(label="说明") 请填写用于微众钱包提现的银行卡信息，可以与收款账户绑定的银行卡信息一致。
        data-row(label="开户名", required)
          el-input(v-model="createWallet.source.deposit_name")
        data-row(label="开户银行", required)
          el-input(v-model="createWallet.source.deposit_bank")
        data-row(label="银行账号", required)
          el-input(v-model="createWallet.source.bank_account")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveCreateWallet()") 保存
        el-button(@click="hideCreateWallet()") 取消

    verifier(ref="bindAccount", @success_verify="toBind", scene="BIND_BANKCARD", opt="MCH_VERIFY")
    verifier(ref="unbindAccount", @success_verify="toUnbind", scene="BIND_BANKCARD", opt="MCH_VERIFY")
</template>

<script>
export default {
  data () {
    return {
      accountDetail:  {},
      editAccount:    {
        show:     false,
        desc:     null,
      },

      accountList:    {
        page:   1,
        size:   5,
        status: 0,
        list:   [],
        total:  0,

        listLoading:  false,
      },

      editBinding: {
        show:           false,
        accountList:    [],
        settle_account: null,
        loading:        false,
      },

      walletConfig:   {},
      createWallet: {
        show:     false,
        source:   {
          account_id:       null,
          desc:             null,
          deposit_name:     null,
          deposit_bank:     null,
          bank_account:     null,
        },
      },

      bindingAccountId:   null,

      settleDetail:   {},
    };
  },
  computed: {
    settle_type () {
      return this.$store.getters.userInfo.settle_type;
    },
    account_id () {
      return this.$route.params.account_id;
    },
    iface () {
      const privileges = this.$store.getters.privileges;
      let iface = {};
      privileges.forEach(({ url }) => {
        switch (url) {
          case '/mch_web/v1/settle/add_account':    iface.toAddAccount = true; break;
          case '/mch_web/v1/settle/edit_account':   iface.toEditAccount = true; break;
          case '/mch_web/v1/settle/cfg':            iface.toBind = true; break;
          case '/mch_web/v1/settle/discfg':         iface.toUnbind = true; break;
        }
      });
      return iface;
    },
  },
  methods: {
    showEditAccount () {
      this.editAccount = {
        show:     true,
        desc:     this.accountDetail.desc,
      };
    },
    hideEditAccount () {
      this.editAccount = {
        show:     false,
        desc:     null,
      };
    },
    saveEditAccount () {
      if (!this.editAccount.desc) {
        this.$message({
          type:     'warning',
          message:  `请输入账户名称`
        });
        return false;
      }

      const params = {
        account_id:   this.account_id,
        desc:         this.editAccount.desc
      };
      this.$store.dispatch('EDIT_ACCOUNT_DETAIL', params).then(() => {
        this.getAccountDetail();
        this.hideEditAccount();

        this.$message({
          type:     'success',
          message:  '修改成功'
        });
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `修改失败。${code}：${msg}`,
        });
      });
    },

    showCreateWallet () {
      this.createWallet = {
        show:     true,
        source:   {
          account_id:       this.account_id,
          desc:             this.accountDetail.desc,
          deposit_name:     null,
          deposit_bank:     null,
          bank_account:     null,
        },
      };
    },
    hideCreateWallet () {
      this.createWallet = {
        show:     false,
        source:   {
          account_id:       null,
          desc:             null,
          deposit_name:     null,
          deposit_bank:     null,
          bank_account:     null,
        },
      };
    },
    saveCreateWallet () {
      if (!this.createWallet.source.deposit_name || !this.createWallet.source.deposit_bank || !this.createWallet.source.bank_account) {
        this.$message({
          type:     'warning',
          message:  `请输入开户名、开户银行和银行账号`
        });
        return false;
      }

      this.$store.dispatch('CREATE_WALLET', this.createWallet.source).then(() => {
        this.getWalletConfig();
        this.hideCreateWallet();

        this.$message({
          type:     'success',
          message:  '富力钱包添加成功，请完成验证操作'
        });
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `富力钱包添加失败。${code}：${msg}`,
        });
      });
    },

    changeAccountStatus ({ id, status }) {
      this.$store.dispatch('UPDATE_SETTLE_ACCOUNT_STATUS', { id, status }).then(() => {
        this.$message({
          type:     'success',
          message:  '状态修改成功'
        });

        this.refresh();
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `状态修改失败：${code}：${msg}`
        });
        this.refresh();
      });
    },

    showEditBinding () {
      this.editBinding = {
        show:           true,
        accountList:    [],
        settle_account: null,
        loading:        false,
      };
      this.getSettleAccountList();
    },
    hideEditBinding () {
      this.editBinding = {
        show:           false,
        accountList:    [],
        settle_account: null,
        loading:        false,
      };
    },
    getSettleAccountList () {
      this.editBinding.loading = true;
      this.$store.dispatch('GET_SETTLE_ACCOUNT_LIST_BY_PAYMENT_ACCOUNT', {
        offset:   0,
        limit:    50,
        stat:     true,
        account_id: this.account_id,
      }).then((data) => {
        this.editBinding.accountList = data.list;
      }).catch(({ msg }) => {
        this.$alert(`${msg}`, {
          type:     'error'
        });
      }).finally(() => {
        this.editBinding.loading = false;
      });
    },
    toEditBinding (settle_account) {
      this.$confirm('是否确定把此收款账户绑定到该结算账户？', {
        type:     'danger'
      }).then(() => {
        this.editBinding.settle_account = settle_account;
        this.$refs.bindAccount.init();
      }).catch(() => {

      });
    },
    toEditUnbinding (settle_account) {
      this.$confirm('是否确定解除此收款账户与该结算账户之间的绑定？', {
        type:     'danger'
      }).then(() => {
        this.editBinding.settle_account = settle_account;
        this.$refs.unbindAccount.init();
      }).catch(() => {

      });
    },

    toBind (biz_ticket) {
      this.$store.dispatch('BIND_ACCOUNT', {
        account_id:       this.account_id,
        settle_account:   this.editBinding.settle_account,
        biz_ticket,
        type:           1,
      }).then(() => {
        this.$message({
          type:     'success',
          message:  '绑定成功'
        });

        this.getSettleAccountList();
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `绑定失败：${code}：${msg}`
        });
      });
    },
    toUnbind (biz_ticket) {
      this.$store.dispatch('UNBIND_ACCOUNT', {
        account_id:       this.account_id,
        settle_account:   this.editBinding.settle_account,
        biz_ticket,
      }).then(() => {
        this.$message({
          type:     'success',
          message:  '解绑成功'
        });

        this.getSettleAccountList();
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `解绑失败：${code}：${msg}`
        });
      });
    },

    getAccountDetail () {
      const account_id = this.account_id;

      return this.$store.dispatch('GET_ACCOUNT_DETAIL', account_id).then((data) => {
        this.accountDetail = data;
        return data;
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取账户信息失败。${code}：${msg}`,
        });
      });
    },

    toWalletVerify (account_id) {
      this.$router.push(`/payment/${account_id}/verify`);
    },
    toWalletDetail (account_id) {
      this.$router.push(`/payment/${account_id}/detail`);
    },

    getWalletConfig () {
      const account_id = this.account_id;

      return this.$store.dispatch('GET_WALLET_CONFIG', account_id).then((data) => {
        this.walletConfig = data;
        return data;
      }).catch(({ code, msg }) => {
        if (code !== 45109) {
          this.$message({
            type:     'error',
            message:  `获取结算钱包信息失败。${code}：${msg}`,
          });
        }
      });
    },
    getSettleDetail () {
      const account_id = this.account_id;

      return this.$store.dispatch('GET_SETTLE_CONFIG_DETAIL', account_id).then((data) => {
        this.settleDetail = data;
        return data;
      }).catch(({ code, msg }) => {
        if (code !== 45104) {
          this.$message({
            type:     'error',
            message:  `获取结算绑定账号信息失败。${code}：${msg}`,
          });
        }
      });
    },
    getWalletDetail () {
      const account_id = this.account_id;

      return this.$store.dispatch('GET_WALLET_DETAIL', account_id).then((data) => {
        return data;
      }).catch(({ code, msg }) => {
        if (code !== 45104) {
          this.$message({
            type:     'error',
            message:  `获取结算绑定账号信息失败。${code}：${msg}`,
          });
        }
      });
    },

    refresh () {
      this.getAccountList(this.accountList.page);
    },
    changeListSize (size = 10) {
      this.accountList.size = size;
      this.getAccountList(1);
    },
    getAccountList (page = 1) {
      if (!this.accountList.listLoading) {
        this.accountList.page = page;
        this.accountList.listLoading = true;
      } else {
        return;
      }
      const account_id = this.account_id;

      this.$store.dispatch('GET_SETTLE_ACCOUNT_LIST', {
        account_id,
        offset:   this.accountList.size * (this.accountList.page - 1),
        limit:    this.accountList.size,
        stat:     true,
      }).then((data) => {
        this.accountList.list = data.list;
        this.accountList.total = data.total;
      }).catch(({ msg }) => {
        this.$alert(`${msg}`, {
          type:     'error'
        });
      }).finally(() => {
        this.accountList.listLoading = false;
      });
    },

    init () {
      this.getAccountDetail();
      this.getWalletConfig();
      this.getSettleDetail();
      this.getAccountList(1);
    },
  },
  mounted () {
    if (!this.account_id) {
      this.$router.replace('/paymentList-mobile');
    } else {
      this.init();
    }
  },
};
</script>

<style lang="less">
@import (reference) "../../assets/general";

.container-payment-mobile {
  .account-title {
    margin-bottom:  10px;
  }
  .account-list-title {
    padding:  10px 20px 0;
    margin-bottom:  20px;
  }
  .account-item {
    padding:  0;
    margin:   0 0 10px;
  }
  .account-item-content {
    .border-box;
    .flex(center, space-between);
    .max-width;
    padding:    10px 20px;
    font-size:  14px;
    
    border-top: 1px solid @hr-grey;

    &:last-child {
      border-bottom:  1px solid @hr-grey;
    }
  }
}
</style>
